
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

@Component
export default class demo_home extends Vue {
    openKeys: Array<string> = [];

    get routerPath() {
        //解决路由切换到添加或编辑页面后实现侧边栏高亮
        // @ts-ignore
        return this.$route.meta.active ? this.$route.meta.jumpPath : this.$route.path;
    }

    titleClick(): void {}
    handleClick(path: string): void {
        this.$router.push({
            path: path,
            query: {}
        });
    }
    onOpenChange(): void {}
}
